import { LottieProps } from 'lottie-react-web';

import { LazyComponent, lazyWithNullFallback } from 'components/layout/util';

export const Animation: LazyComponent<Omit<LottieProps, 'options'>> = lazyWithNullFallback(() =>
  import('./favorite-loading')
);
